export default __webpack_public_path__ + "static/media/copy-right-footer.7e0ccb3b.svg";